import { useEffect }         from "react";
import {
  useDispatch,
  useSelector
}                            from "react-redux";
import { ApplicationState }  from "../store";
import { APIState }          from "../store/API/types";
import {
  getLayoutInfo,
  setCurrentLayout
}                            from "../store/layouts/actions";
import { LayoutState }       from '../store/layouts/types';
import { setStoredSettings } from "../store/settings/actions";
import { chooseService }     from "../utils";


const getLocalStorageData = (username: string, id: string) => {
  if (!username || !id) return [];

  return Object.entries(window.localStorage)
    .map(([key, value]) => [key.split('/'), value.split('/')])
    .filter(([keys, _]) => keys[0] === username && keys[1] === id)
    .map(([_, values]) => values);
};

const getFromArr = (arr: any) => {
  while (arr instanceof Array) {
    arr = arr[0]
  }
  return arr
};

const isLocalStored = (username: string, id: string, flag?: string) => {
  const vals = getLocalStorageData(username, id);
  return flag ? getFromArr(vals) === flag : getFromArr(vals);
};

const useSetStoredData = () => {
  const dispatch = useDispatch();
  const {layouts, username} = useSelector<ApplicationState, APIState>(state => state.API);
  const {initialView} = useSelector<ApplicationState, LayoutState>(state => state.layouts)

  useEffect(() => {
    const useSettings = isLocalStored(username, 'localSettings', 'true');
    const loadLastView = isLocalStored(username, 'loadLastView', 'true');
    const paneIsResponsive = isLocalStored(username, 'responsive', 'true');
    const notificationPriority = isLocalStored(username, 'notifications');
    const alarmPriority = isLocalStored(username, 'sounds');
    const isLocalTime = isLocalStored(username, 'timeLocal', 'true');
    const timeZone = isLocalStored(username, 'timeZone');
    const layoutType = isLocalStored(username, 'layoutType');
    const clearTextAfterSelection = isLocalStored(username, 'clearText', 'true');
    const storedLayoutData = loadLastView ? getLocalStorageData(username, 'layoutId') : [];

    if (useSettings) {
      dispatch(setStoredSettings({
        localSettings: useSettings,
        isLocalTime,
        timeZone,
        paneIsResponsive,
        loadLastView,
        clearTextAfterSelection,
        alarmPriority,
        notificationPriority
      }));
    }

    if (useSettings && storedLayoutData.length) {
      let localViews: any = null;
      const getViews = (children: any[], name: string, views: any[]): any => {
        if (name === storedLayoutData[0][0] && !localViews) {
          localViews = views.find(view => view.name === storedLayoutData[0][1])
        } else if (name !== storedLayoutData[0] && children.length && !localViews) {
          children.map(child => getViews(child.children, child.id, child.views));
        }
        return localViews
      };
      chooseService(
        () => getViews(layouts.children, layouts.id, layouts.view),
        () => dispatch(getLayoutInfo(storedLayoutData[0][0], layoutType, storedLayoutData[0][1], true))
      );

      if (localViews) {
        dispatch(setCurrentLayout({id: storedLayoutData[0][0], view: localViews, layoutType}));
      }
    } else {
      dispatch(setCurrentLayout({id: '1', view: initialView, layoutType: 'Layer'}));
    }
  }, [layouts]);
};

export default useSetStoredData